__webpack_require__.p = "/pan-weeks-dashboard/";